var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamanicsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1196 157.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 387.31,
    y1: 125,
    x2: 371.42,
    y2: 133.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 421.25,
    y1: 66.95,
    x2: 444.05,
    y2: 53.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 85.09,
    y1: 18.74,
    x2: 85.09,
    y2: 84.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 137.52,
    y1: 18.74,
    x2: 137.52,
    y2: 84.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 32.34,
    y1: 18.74,
    x2: 32.34,
    y2: 84.19,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_White",
    "data-name": "Layer 1 White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_White",
    "data-name": "Logo White"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.19,34.1H200.75V.18h113.3V34.1H276.81V151.39H238.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M483.48,39.84h31.67V51.9a26.73,26.73,0,0,1,7-8c4.91-4.09,12.87-8,24.73-8a34.61,34.61,0,0,1,25.95,10.83,38.31,38.31,0,0,1,6.74,9.4,46.54,46.54,0,0,1,8.18-9.81A40.21,40.21,0,0,1,615.49,36c8,0,20.64,1.84,29.83,11.44C656,58.64,657.58,66.2,657.58,91.34v61.92H623.66V93c0-4.7,0-10.83-2.25-15.94-2-5.31-6.33-9.19-15.12-9.19-9.4,0-14.1,4.29-16.35,9.4-2.45,5.11-2.45,10.83-2.45,14.1v61.92H553.57V91.54c0-3.06,0-9-2-14.1-2.25-5.31-6.34-9.6-14.92-9.6-9.6,0-14.3,4.49-16.76,10S517.4,89.5,517.4,93v60.29H483.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M806.34,39.84H838V51.9c3.88-5.52,11-15.94,31.26-15.94,38.21,0,42.1,31.06,42.1,46.39v70.91H877.45V91.34c0-12.47-2.65-23.5-17.77-23.5-16.76,0-19.42,12.06-19.42,23.7v61.72H806.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M927.88,2H961.8V27.79H927.88Zm0,37.8H961.8V153.26H927.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1096.19,110.14a60.5,60.5,0,0,1-59.46,46.79c-34.33,0-60.69-27-60.69-60.69,0-33.3,26-60.28,59.87-60.28,30,0,54.36,19.82,60.08,47.61h-34.33c-3.68-7.76-10.42-15.93-24.52-15.93a24.36,24.36,0,0,0-19.62,8c-4.7,5.32-7.36,12.67-7.36,20.85,0,16.55,10.83,28.81,27,28.81,14.1,0,20.84-8.17,24.52-15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1159.22,71.72c-.21-2.45-.62-8.58-10.63-8.58-7.15,0-9.6,4.5-9.6,7.56,0,5.11,8.38,8.58,17.37,11.24,19.21,5.31,39.64,11,39.64,35.56,0,24.93-21,39.64-46.18,39.64-17.17,0-43.12-7.77-46.18-37.6h33.71C1138.78,130,1148.8,130,1150.23,130c5.72,0,11.85-3.27,11.85-8.79,0-7.76-8.38-8.78-30-17.16-14.71-4.7-27-14.31-27-29.63,0-23.5,20.43-38.42,43.93-38.42,14.92,0,40.67,5.93,43.53,35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.72,64.78a30.8,30.8,0,0,0-27.3,16.54H382A30.79,30.79,0,0,0,354.72,64.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M398.16,136.37c-4.56-7.21-9.08-18.27-14.48-30.23a30.83,30.83,0,0,1-24.76,20l13.34,26.39A59.56,59.56,0,0,0,398.16,136.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M483.08,39.41V44.8a59.14,59.14,0,0,0-30.88-8.71,59.86,59.86,0,0,0-12.51,1.33L458,65.34a30.83,30.83,0,1,1-31,48l0,0v-.08c-7.16-7.38-14.11-30.52-24.2-52.88a59.56,59.56,0,1,0-30.51,92.12l-13.34-26.39a30.48,30.48,0,0,1-34.47-24.72h65.49a233.48,233.48,0,0,0,17.41,33l-.08.17a59.24,59.24,0,0,0,75.81,11.87v5.87h31.34V39.41ZM327.42,81.32a30.78,30.78,0,0,1,54.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M409.23,54.51a305,305,0,0,0,13,34,30.82,30.82,0,0,1,30-23.76,31.59,31.59,0,0,1,5.8.56L439.69,37.42A59.48,59.48,0,0,0,409.23,54.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M789.22,150.69H756v-12c-6,10.79-19.79,15.79-32.78,15.79-35.18,0-55.77-27.58-55.77-59.36,0-36.38,26.19-59.17,55.77-59.17,18.19,0,28.38,8.8,32.78,15.59V39.76h33.18Zm-88.55-55c0,10.2,7.6,27.79,27.59,27.79,11.79,0,19-5.6,23.18-12.4A30.48,30.48,0,0,0,756,96.92a28.5,28.5,0,0,0-2.8-14.59c-3.6-7.59-11.19-15.39-25.18-15.39-19,0-27.39,16-27.39,28.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "85.09 152.33 85.1 152.33 85.09 152.33 85.09 152.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.8 145.65 85.09 152.33 85.09 152.33 85.1 152.33 67.1 22.63 73.8 145.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143.29,22.88a85.45,85.45,0,0,0-116.39,0L44.69,35.1c8.67-7,13-9.33,22.41-12.47l18,129.7,18-129.7c9.42,3.14,13.74,5.51,22.41,12.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "96.39 145.65 103.09 22.63 85.1 152.33 96.39 145.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165.14,57.1a85.65,85.65,0,0,0-15-26.54L139.33,38l0-.06L106.84,61.3l-1.66,24.81,38.15-27.29a64.54,64.54,0,0,1-7.56,65.46,65,65,0,0,1-14.35,13.8l18.09,12.43A86.42,86.42,0,0,0,153,136.13a85.63,85.63,0,0,0,12.12-79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4.72,57.1a85.08,85.08,0,0,1,15-26.54L30.53,38l0-.06L63,61.3l1.67,24.81L26.52,58.82a64.57,64.57,0,0,0,21.92,79.26L30.35,150.51A85.59,85.59,0,0,1,4.72,57.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamanicsLogo);
export default __webpack_public_path__ + "static/media/teamanics_logo.5ebfe5841be55ef9010893eaa67fefa9.svg";
export { ForwardRef as ReactComponent };